import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconVoiceSparkle: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconVoiceSparkle"><Path d="M9 21H7V3H9V21Z" fill="currentColor"/><Path d="M16.4004 13L17.4004 15.5996L20 16.5996V17.4004L17.4004 18.4004L16.4004 21H15.5996L14.5996 18.4004L12 17.4004V16.5996L14.5996 15.5996L15.5996 13H16.4004Z" fill="currentColor"/><Path d="M5 15H3V9H5V15Z" fill="currentColor"/><Path d="M13 14H11V7H13V14Z" fill="currentColor"/><Path d="M21 14H19V9H21V14Z" fill="currentColor"/><Path d="M17 11H15V5H17V11Z" fill="currentColor"/></CentralIconBase>;
});

export default IconVoiceSparkle;
